import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["skip", "popularTermsLimit", "quickLinksLimit"];
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { rpcClient } from '../../client';
import { getAutocompleteSuggestionsRpc } from 'academy-service-client/academy-autocomplete/v1/operations';
export const GET_SEARCH_AUTOCOMPLETE = registerQuery({
  fieldName: 'getSearchAutocomplete',
  args: ['queryTerm', 'popularTermsLimit', 'quickLinksLimit', 'language', 'userId', 'portalId'],
  fetcher(queryParameters) {
    return rpcClient.call(getAutocompleteSuggestionsRpc, {
      queryParameters
    });
  }
});
export const useSearchAutocomplete = _ref => {
  let {
      skip,
      popularTermsLimit = 6,
      quickLinksLimit = 3
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    data: suggestions,
    loading: suggestionsLoading,
    error: suggestionsError
  } = useQuery(GET_SEARCH_AUTOCOMPLETE, {
    skip,
    variables: Object.assign({
      popularTermsLimit,
      quickLinksLimit
    }, props)
  });
  return {
    suggestions,
    suggestionsLoading,
    suggestionsError
  };
};